<!--
Renders a link to Google Play or Apple App Store if the user is in the web app and the device is compatible.
Usage: <AppStoreLink iosLink="" androidLink="" :displayOnlyWeb=''/>
if props omitted, links defaults to uofglife
@author bmk11u, crm4f
-->
<template>
  <div class="text-center">
    <a v-if="displayOnlyWeb ? ((web && os) === 'iOS') : ((os) === 'iOS')" :href='iosLink'>
      <img alt='Download on the App Store' src='@/assets/apple-app-store-badge.svg' width="180" height="50"  class="mt-3 mb-3" />
    </a>
    <a v-if="displayOnlyWeb ? ((web && os) === 'Android') : ((os) === 'Android')" :href='androidLink'>
      <img alt='Get it on Google Play' src='@/assets/google-play-badge.png' />
    </a>
  </div>
</template>

<script setup>
//Utilities
import { ref } from 'vue'
import { useDeviceType } from '@/composables/DeviceCommon.js'
const  os  = useDeviceType()

const props = defineProps({
  iosLink: {
      type: String,
      default: 'https://apps.apple.com/us/app/timetable-room-finder/id1479855374?ls=1'
    },
    androidLink: {
      type: String,
      default: 'https://play.google.com/store/apps/details?id=uk.ac.gla.timetable&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
    },
    displayOnlyWeb: {
      type: Boolean,
      default: true
    }
})

//Data
const web = (process.env.VUE_APP_MODE !== 'hybrid')


</script>